import React, { useState } from 'react';
import { Form, Transition, Link, Document } from 'components';
import { api, isEmail, cookies, encrypt, delay, config, find, useQuery, useLocation } from 'helpers';
import { errors } from '.';
import css from './short.scss';

export function SignUp(props) {
  let { email, redirect } = useQuery();
  const { search } = useLocation();
  const [ state, setState ] = useState({
    email: email || '',
  });

  async function submit({ values, setError, setPending, setSuccess }) {
    if (!values.email) {
      return setError('email', 'please enter your email');
    } else if (!isEmail(values.email)) {
      return setError('email', 'please enter valid email');
    } else if (!values.password) {
      return setError('password', 'please enter your password');
    } else if (values.password.length < 6) {
      return setError('password', 'must be at least 6 characters');
    } else if (values.password.length > 15) {
      return setError('password', 'must be no longer than 15 characters');
    } else if (values.password != values.password2) {
      return setError('password2', 'entered passwords do not match');
    }

    setPending();

    try {

      cookies.remove('token', { domain: config.appHost });

      await api('/register/', {
        email: values.email,
        password: values.password,
        password2: values.password2,
        device: 'Web'
      });

      window.fbq && window.fbq('track', 'CompleteRegistration');

      const { token } = await api('/login/', {
        email: values.email,
        password: values.password,
        device: 'Web',
      });

      cookies.set('token', encrypt(token), { expires: 365, domain: config.appHost });
      cookies.set('email', values.email, { expires: 365 });
      cookies.set('signing-up', '1', { domain: config.appHost });

      if (props.module == 'go-premium') {
        redirect = '/settings/membership/';
      }

      let appRedirect = `https://app.${config.appHost}${redirect || '/'}?${Math.random()}`;
      const plan = find(config.plans, { code: props.option });
      if (plan) {
        const { url } = await api('/start-payment/', { productCode: plan.code });
        if (/^http/.test(url)) appRedirect = url;
      }

      setSuccess();

      await delay(1000);

      window.location = appRedirect;

    } catch ({ error }) {
      setError('email', errors[error] || 'Error. Please try again');
    }

    setPending(false);
  }

  return (
    <Transition in={props.active} mountOnEnter unmountOnExit classNames={css.locals} timeout={500}>
      <Form onSubmit={submit} state={state} setState={setState} className={css('form', 'appear'+props.status)} autoComplete="off">
        <Document.Title>Sign Up</Document.Title>
        <p><Form.Text name="email" label="Email" /></p>
        <p><Form.Password name="password" label="Password" /></p>
        <p className={css.tip}>*must be at least 6 and no longer than 15 characters</p>
        <p><Form.Password name="password2" label="Confirm password" /></p>
        <p><Form.Submit>Sign Up</Form.Submit></p>
        <p className={css.footer}>
          <span>Already have an account? </span>
          <Link to={`/login/${search}`}>Login</Link>
        </p>
        <p className={css.legend}>By singing up you agree to the <Link to="/privacy/">Privacy Policy</Link> and <Link to="/terms/">Terms of Use</Link></p>
        { state.success &&
          <div className={css.cover}>
            <p>redirecting now..</p>
          </div>
        }
      </Form>
    </Transition>
  );
}
